
// en-GB.ts

export default {
  // Download G-Trader App
  'downloadGTraderApp': 'Download G-Trader App',
  'multipleForexTrading': 'Multiple Forex Trading - Easy to Start, Simple and Worry-free',
  'androidDownload': 'Android ',
  'iosDownload': 'iOS ',
  'scanQrCode': 'Scan QR Code to Download APP',

  // Download Trading Platform
  'downloadTradingPlatform': 'Download Trading Platform',
  'metaTrader4': 'Meta Trader 4',
    'android': 'Android Download',
  'appStoreDownload': 'App Store Download',
  'windowsDownload': 'Windows Download',
  'macOSDownload': 'MacOS Download',
  'metaTrader5': 'Meta Trader 5'
};
